// import "url-polyfill";
/** Per la login con il solo TSID chiamiamo la USER_READ_API_URL_V3 */
import { /* USER_READ_API_URL,*/ USER_READ_API_URL_V3, APP_PDC_URL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import axios from "axios";
import { callWithRetry } from "../../services/callWithRetry";

export const usersConstants = {
  LOAD_USER_START: "LOAD_USER_START",
  LOAD_USER_SUCCESS: "LOAD_USER_SUCCESS",
  LOAD_USER_ERROR: "LOAD_USER_ERROR",

  GET_ACCOUNT_USERS_START: "GET_ACCOUNT_USERS_START",
  GET_ACCOUNT_USERS_SUCCESS: "GET_ACCOUNT_USERS_SUCCESS",
  GET_ACCOUNT_USERS_ERROR: "GET_ACCOUNT_USERS_ERROR",

  PUT_ACCOUNT_USERS_PASSWORD_START: "PUT_ACCOUNT_USERS_PASSWORD_START",
  PUT_ACCOUNT_USERS_PASSWORD_SUCCESS: "PUT_ACCOUNT_USERS_PASSWORD_SUCCESS",
  PUT_ACCOUNT_USERS_PASSWORD_ERROR: "PUT_ACCOUNT_USERS_PASSWORD_ERROR"
};

export function loadUser() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const userId = auth?.loginAuth?.id;
    let request = {
      method: "get",
      url: USER_READ_API_URL_V3 + "/" + userId,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth?.securityToken)
    };
    return new Promise((resolve, reject) => {
      dispatch({
        type: usersConstants.LOAD_USER_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: usersConstants.LOAD_USER_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: usersConstants.LOAD_USER_ERROR,
            payload: {
              message: response.response ? response.response.data.message : response.toString()
            }
          });
          reject();
        });
    });
  };
}

export function updatePassword(
  auth, id, sha256
) {
  let request = {
    method: "PUT",
    url: APP_PDC_URL + "/user/updatePassword",
    headers: createHttpHeaderWithAuthorization(auth.securityToken),
    data: {
      authWithAppName: {
        appName: "DIGITALBOXWEB",
        id: id,
        securityToken: auth.securityToken
      },
      request: {
        sha256UserPassword: sha256,
        userId: id
      }
    }
  };

  return function(dispatch) {
    dispatch({
      type: usersConstants.PUT_ACCOUNT_USERS_PASSWORD_START
    });

    return axios(request)
      .then((result) => {
        dispatch({
          type: usersConstants.PUT_ACCOUNT_USERS_PASSWORD_SUCCESS
        });
      })
      .catch((response) => {
        dispatch({
          type: usersConstants.PUT_ACCOUNT_USERS_PASSWORD_ERROR,
          payload: {
            code: response.code ? response.code : null,
            message: "Password non aggiornata correttamente"
          }
        });
      });
  };
}
